export default {
  main: {
    site_id: 18775101,
    title: "Terminal PRO",
    showBetBuilderSection: true,
    terminalId: 41943,
    showExitButton: true,
    headerPagesLeftDistance: 170,
    needAdminForResetPin: false,
    ticketAvailableViewMode: ["card"],
    enableTicketAutoCashoutAmountUpdate: false,
    enableTicketPopupFlow: true,
    enableTicketTimer: true,
    timeFormat: "HH:mm",
    isWithdrawal: true,
    useWithdrawV1: true,
    restrictedAdminPrintableTicketsCount: 5,
    hasDayFilter: true,
    enableHeaderAdminSection: true,
    loadUserCurrencyConfig: true,
    availableCurrencies: ["XAF", "XOF", "UGX", "KES", "USD", "ETB", "TRY", "TZS", "PHP", "CFA", "SSP", "ZAR", "EGP", "ZMW", "EUR", "GBP"],
    homeMediaSlides: [
      {
        type: "main",
        path: "betting/prematch",
        fileType: "webp"
      },
      {
        type: "sport",
        path: "betting/prematch",
      },
    ],
    websitePasswordHash: "",
    logoSize: "medium",
    signInType: 'phone',
    enableRegistration: true,
    availableLanguages: {
      '@replace': true,
      eng: {
        short: 'EN',
        name: 'Eng',
        region: 'UnitedKingdom',
        order: 1,
      },
      swa: {
        short: 'SW',
        name: 'SWA',
        region: 'Kenya',
        order: 2,
      },
    },
  },
  registrationFormConfigs: {
    registrationFormSteps: [
      {
        name: 'personal_information',
        label: '',
        fields: [
          { name: 'phoneNumber', enabled: true },
          { name: 'currency', enabled: true },
          { name: 'password', enabled: true },
          { name: 'confirmPassword', enabled: true },
          { name: 'rull18', enabled: true },
        ],
      },
    ],
    country: 'Kenya',
    enableCountryNameForPhoneCode: true,
    registrationUserName: 'phoneNumber',
  },
  header: {
    disableCashout: true,
    disableAnonymousBalance: true,
  },
  tickets: {
    disableFlow: true,
  },
  env: {
    lang: "eng",
  },
  settingsSection: {
    sections: ['oddsType', 'language'],
  },
  routes: [
    {
      url: "betting/live",
      name: "Live",
      enabled: true,
      icon: 'circle',
    },
    {
      url: "betting/prematch",
      name: "Sports",
      enabled: true,
      type: "sportsBook",
      nestedItems: [
        {
          url: 'betting/prematch/all',
          type: 'prematch',
          name: 'All Matches',
          enabled: true,
          icon: 'casino-categories-Sportsbook',
        },
        {
          url: 'betting/prematch/betBuilder',
          type: 'betBuilder',
          name: 'Bet Builder',
          enabled: true,
          icon: 'bet-builder',
        },
        {
          url: 'betting/prematch/popular',
          type: 'popular',
          name: 'Popular',
          enabled: true,
          icon: 'casino-categories-PopularGames',
        },
        {
          url: 'betting/prematch/outrights',
          name: 'Outrights',
          type: 'outrights',
          enabled: true,
          icon: '',
        },
      ],
    },

    {
      url: "betting/results",
      name: "Results",
      enabled: true,
    },
    {
      url: "tickets",
      name: "Tickets",
      enabled: true,
    },
    {
      url: "bethistory",
      name: "Bet History",
      enabled: true,
      disableInHeader: true,
    },
  ],
  defaultTerminalParams: { pid: 18775101, tid: 42016, token: "DkZjMA==", currency: "KES" },
  sportsbook: {
    enableBoostedOdds: true,
    enablePredefinedMultiples: true
  }
};
